import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import PageHeader from '../components/PageHeader'
import { imageUrl } from '../lib/images'
import IndsatserModal from '../components/IndsatserModal'

export default function Services() {
  const [selectedIndsats, setSelectedIndsats] = useState(null)
  const INDSATSER_ITEMS = [
    {
      title: 'Styrke unges livsmestring og trivsel',
      desc: 'Vi støtter den enkelte unge i at mestre hverdagen, styrke selvværdet og finde troen på egne evner og potentialer.',
      icon: 'fa-heart-pulse'
    },
    {
      title: 'Forebygge ensomhed, marginalisering og kriminalitet',
      desc: 'Gennem faste relationer og sunde fællesskaber skaber vi tryghed og alternativer til mistrivsel og isolation.',
      icon: 'fa-shield-halved'
    },
    {
      title: 'Støtte unge i at gennemføre en uddannelse',
      desc: 'Vi hjælper unge i overgangen fra udskolingen til uddannelse og job',
      icon: 'fa-graduation-cap'
    },
    {
      title: 'Hjælpe unge i beskæftigelse eller anden meningsfuld aktivitet',
      desc: 'Brobygning til arbejdsmarkedet gennem fritidsjob, praktikpladser, småjob og skånejob i et trygt tempo.',
      icon: 'fa-briefcase'
    },
    {
      title: 'Etablere mentorordninger, netværk og frivillige fællesskaber',
      desc: 'Én-til-én mentorordninger med engagerede rollemodeller samt sociale netværk, hvor unge kan spejle sig i hinanden.',
      icon: 'fa-user-group'
    },
    {
      title: 'Udvikle og gennemføre sociale projekter og indsatser',
      desc: 'Målrettede initiativer, aktivitetsforløb, workshops og sociale indsatser med fokus på unges trivsel og udvikling.',
      icon: 'fa-diagram-project'
    },
    {
      title: 'Skabe samarbejde mellem civilsamfund, kommuner, virksomheder og uddannelsesinstitutioner',
      desc: 'Tværfaglig brobygning og stærke partnerskaber, så samfundets ressourcer løfter i fællesskab omkring den unge.',
      icon: 'fa-handshake'
    },
    {
      title: 'Indsamle og formidle viden om virkningsfulde indsatser for unge',
      desc: 'Erfaringsopsamling, videndeling og dokumentation af metoder, der skaber varig og målbar forandring for målgruppen.',
      icon: 'fa-book-open-reader'
    }
  ]

  return (
    <div>
      <PageHeader
        badge="Aktiviteter i hele Danmark"
        title="Vores arbejde og indsatser"
        subtitle="Foreningens formål er at støtte og hjælpe sårbare og udsatte unge mellem 10 og 29 år til et godt liv gennem udvikling af deres kompetencer."
        breadcrumb={[{ label: 'Vores arbejde' }]}
      />

      {/* SAMLET SEKTION: INDSATSER */}
      <section className="py-16 sm:py-24 bg-white border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center mb-16">
            {/* Tekst */}
            <div className="lg:col-span-7 space-y-6">
              <span className="text-xs font-bold uppercase tracking-wider text-[#f39223]">
                Kerneområder
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0c304d] tracking-tight">
                Indsatser
              </h2>
              <div className="space-y-4 text-neutral-700 text-base sm:text-lg leading-relaxed">
                <p>
                  Foreningens formål er at støtte og hjælpe sårbare og udsatte unge mellem 10 og 29 år til et godt liv gennem udvikling af deres personlige, sociale, kulturelle, sproglige og faglige kompetencer.
                </p>
                <p className="font-semibold text-[#0c304d]">
                  Her kan du se eksempler på de områder, vi arbejder med lige nu:
                </p>
              </div>

              <div className="p-4 rounded-xl bg-amber-50 border border-amber-200/80 flex items-center gap-3">
                <i className="fa-solid fa-location-dot text-[#f39223] text-lg shrink-0" aria-hidden="true" />
                <p className="text-sm font-bold text-[#0c304d]">
                  Foreningen udfører aktiviteter i hele Danmark.
                </p>
              </div>
            </div>

            {/* Billede: COLOURBOX20897112 */}
            <div className="lg:col-span-5">
              <div className="rounded-3xl overflow-hidden shadow-xl border-4 border-white bg-neutral-100">
                <img
                  src={imageUrl('/_assets/colourbox20897112.jpg', 'width=800,quality=85,format=auto')}
                  alt="Person stående foran en skolebygning"
                  className="w-full h-[360px] sm:h-[420px] object-cover"
                  width={500}
                  height={420}
                />
              </div>
            </div>
          </div>

          {/* De 8 klikbare indsats-bokse med beskrivelse */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-6">
            {INDSATSER_ITEMS.map((item, idx) => (
              <button
                key={idx}
                type="button"
                onClick={() => setSelectedIndsats(item)}
                className="w-full text-left bg-[#faf9f6] hover:bg-white rounded-2xl p-6 border border-neutral-200/90 shadow-2xs hover:shadow-lg hover:border-[#f39223]/70 hover:-translate-y-1 transition-all duration-200 flex flex-col justify-between cursor-pointer group focus:outline-none focus:ring-2 focus:ring-[#f39223]/40"
              >
                <div>
                  <div className="w-12 h-12 rounded-xl bg-amber-50 text-[#f39223] group-hover:bg-[#f39223] group-hover:text-white transition-colors flex items-center justify-center text-xl mb-4">
                    <i className={`fa-solid ${item.icon}`} aria-hidden="true" />
                  </div>
                  <h3 className="text-base font-bold text-[#0c304d] group-hover:text-[#f39223] mb-2 leading-snug transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-neutral-600 text-sm leading-relaxed mb-4">
                    {item.desc}
                  </p>
                </div>
                <div className="pt-2 border-t border-neutral-200/60 flex items-center justify-between text-xs font-semibold text-[#0c304d] group-hover:text-[#f39223] transition-colors">
                  <span>Læs om projektstatus</span>
                  <i className="fa-solid fa-arrow-right group-hover:translate-x-1 transition-transform" aria-hidden="true" />
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* SEKTION 3: HVORDAN GØR VI EN FORSKEL? (Foto: Foto7) */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Billede: Foto7 */}
            <div className="lg:col-span-5 order-2 lg:order-1">
              <div className="rounded-3xl overflow-hidden shadow-xl border-4 border-white bg-neutral-100">
                <img
                  src={imageUrl('/_assets/foto7.jpg', 'width=800,quality=85,format=auto')}
                  alt="Kvinder i caféarbejde og varmt samarbejde"
                  className="w-full h-[460px] object-cover"
                  width={500}
                  height={460}
                />
              </div>
            </div>

            {/* Tekst */}
            <div className="lg:col-span-7 order-1 lg:order-2 space-y-6">
              <span className="text-xs font-bold uppercase tracking-wider text-[#f39223]">
                Vores filosofi
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0c304d] tracking-tight">
                Hvordan gør vi en forskel?
              </h2>
              <div className="space-y-4 text-neutral-700 text-base sm:text-lg leading-relaxed">
                <p>
                  Det positive er, at der ofte skal overraskende lidt til for at gøre en stor forskel. Et menneske, der ser dem. En voksen, der lytter. En mentor, der bliver ved med at tro på dem, også når de selv har mistet troen. En invitation ind i et fællesskab, en hjælpende hånd til den første praktikplads eller bare én, der spørger: Hvordan går det egentlig?
                </p>
                <p>
                  For et udsat barn eller en ung kan én stabil og positiv relation blive begyndelsen på noget helt nyt. Den kan skabe håb, styrke selvværdet og åbne døren til fællesskab, uddannelse og arbejde.
                </p>
                <p className="font-semibold text-[#0c304d]">
                  Nogle gange skal der ikke mere til end ét menneske, der vælger at gøre en forskel.
                </p>
                <p className="text-[#f39223] font-bold text-xl sm:text-2xl">
                  Og den forskel kan vare resten af livet.
                </p>
              </div>

              <div className="pt-2 flex flex-wrap gap-4">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 bg-[#0c304d] hover:bg-[#16466e] text-white font-semibold text-sm px-6 py-3.5 rounded-full transition-colors cursor-pointer shadow-xs"
                >
                  <span>Kontakt os om samarbejde</span>
                  <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                </Link>
                <a
                  href="tel:25778646"
                  className="inline-flex items-center gap-2 bg-neutral-100 hover:bg-neutral-200 text-[#0c304d] font-semibold text-sm px-6 py-3.5 rounded-full transition-colors"
                >
                  <i className="fa-solid fa-phone text-[#f39223]" aria-hidden="true" />
                  <span>Ring 25 77 86 46</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* MODAL FOR INDSATSER */}
      <IndsatserModal
        indsats={selectedIndsats}
        onClose={() => setSelectedIndsats(null)}
      />
    </div>
  )
}
